export const ApplicationName = 'Mediahub';

export const QueryParameterNames = {
    ReturnUrl: 'returnUrl',
    Message: 'message',
};

export const LogoutActions = {
    LogoutCallback: 'logout-callback',
    Logout: 'logout',
    LoggedOut: 'logged-out',
};

export const LoginActions = {
    Login: 'login',
    LoginCallback: 'login-callback',
    LoginFailed: 'login-failed',
    Profile: 'profile',
};

const prefix = '/authentication';

const apiAuthorizationClientConfigurationUrl =
    process.env.REACT_APP_AUTHORIZATION_CONFIGURATION_URL || 'https://api-media.fifa.com/v1/_configuration/Mediahub';

const apiLogoutUrl = process.env.REACT_APP_LOGOUT_URL;

export const ApplicationPaths = {
    ApiAuthorizationClientConfigurationUrl: apiAuthorizationClientConfigurationUrl,
    ApiLogoutUrl: apiLogoutUrl,
    Login: `${prefix}/${LoginActions.Login}`,
    LoginCallback: `${prefix}/${LoginActions.LoginCallback}`,
    LogOut: `${prefix}/${LogoutActions.Logout}`,
    LoggedOut: `${prefix}/${LogoutActions.LoggedOut}`,
    LogOutCallback: `${prefix}/${LogoutActions.LogoutCallback}`,
    IdentityRegisterPath: 'Identity/Account/Register',
    IdentityManagePath: 'Identity/Account/Manage',
};
